module.exports = __webpack_public_path__ + "img/Mirnishii.8f54151a.webp";